import {
  UPDATE_IDCARD_DECTECT
} from "../actions/all_action";

let defaultUserState = {
  card_id: null,
  full_name: null,
  dob: null
};

export const idcardDetection = (state = defaultUserState, action) => {
  switch(action.type)
  {
    case UPDATE_IDCARD_DECTECT:
      const { payload } = action;
      return {
        ...state,
        ...payload 
      }
    ;
    default:
      return state
    ;
  }
}